import i18n from '@/i18n';
import apiFactory from '@/api';
import toastr from '@/helpers/init-toastr';
import { Events, EventBus } from '@/events';
import { ADDON_ACCESS } from '@/configs/accessConfig.js';
import { SET_ADDON_USERS, SET_USER_DATA_PROP } from '@/store/mutations';
const addonsApi = apiFactory.get('addons');

const addons = {
  state: {
    addonUsers: [],
  },
  mutations: {
    [SET_ADDON_USERS]: (state, users) => (state.addonUsers = users),
  },
  getters: {
    getAddonUsers: (state) => state.addonUsers,
  },
  actions: {
    async receiveAddonUsers({ commit }) {
      commit(SET_ADDON_USERS, []);

      try {
        const res = await addonsApi.fetch();

        // Handle the response from the v2 endpoint
        const data =
          res.data?.data?.map((item) => ({
            access: item.access,
            email: item.email,
            // TODO: Migrate to use project_ids in the future
            projects: item.categories || [],
            id: item.id,
            password: '',
          })) || [];

        if (!data.length) {
          data.push({ access: ADDON_ACCESS, email: '', projects: [], password: '' });
        }

        commit(SET_ADDON_USERS, data);
      } catch (error) {
        console.error('Error during Addon Users fetching:', error);
      }
    },
    async soleDeleteAddonUser({ getters, commit }, { user, sync = false }) {
      try {
        await addonsApi.delete(user.id);
        const users = getters.getAddonUsers.filter((storedUser) => storedUser.id && storedUser.id !== user.id);
        if (sync) {
          commit(SET_ADDON_USERS, users);
        }
      } catch (error) {}
    },
    async syncAddonUsers({ getters, commit }, payload) {
      try {
        const apiPayload = {
          disable_master_account: payload.masterDisabled,
          addon_users: payload.users.map((user) => ({
            email: user.email,
            password: user.password || undefined, // Only include password if it's not empty
            access: user.access,
            // TODO: Migrate to use project_ids in the future
            categories: user.projects,
          })),
        };

        for (const user of payload.deletedUsers) {
          await addonsApi.delete(user.id);
        }

        const res = await addonsApi.storeOrUpdate(apiPayload);
        EventBus.emit(Events.CREATE_ADD_ON_USER, { users: payload.users });

        if (res.data?.error) {
          return toastr.e(res.data.error);
        }

        commit(
          SET_ADDON_USERS,
          payload.users.map((user) => ({
            access: user.access,
            email: user.email,
            projects: user.projects,
            id: user.id,
            password: user.password,
          })),
        );

        // Update the master user disabled property
        commit(SET_USER_DATA_PROP, { prop: 'disabled', value: payload.masterDisabled });

        // update the addonMasterDisabled property if addon user
        commit(SET_USER_DATA_PROP, {
          prop: 'addonMasterDisabled',
          value: payload.masterDisabled,
        });

        !getters.isMasterUser && !payload.masterDisabled && toastr.s(i18n.t('addon-users-updated'));
      } catch (error) {
        console.error('Error during Addon Users update:', error);
      }
    },
  },
};

export default addons;
